import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { Icons } from '../../../../shared/helpers/icons';
import { UserDataService } from '../../../../shared/services/userData.service';
import { IEvacuationRoute } from '../../../../shared/models/evacuationRoute';
import { EvacuationRouteService } from '../../../../shared/services/evacuationRoute.service';

@Component({
  selector: 'evacuation-route-form',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule, SpinnerComponent],
  templateUrl: './evacuation-route-form.component.html'
})
export class EvacuationRouteFormComponent implements OnInit {

  icons = Icons;

  @Input() itemToEdit: IEvacuationRoute | null = null;
  @Input() routeType: string = 'fire';   // 'fire' | 'bomb'
  @Input() typeLabel: string = 'Fire';

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<{ type: string, message: string }>();

  currentBuildingId: string | null = null;
  entry: IEvacuationRoute = {};
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private evacuationRouteService: EvacuationRouteService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.entry = this.itemToEdit ? { ...this.itemToEdit } : {};
  }

  get isEdit(): boolean {
    return !!this.itemToEdit?.id;
  }

  get isValid(): boolean {
    return !!(this.entry.route && this.entry.site);
  }

  closeModal(): void {
    this.onClose.emit();
  }

  save(): void {
    if (!this.currentBuildingId || !this.isValid) return;

    const payload: Partial<IEvacuationRoute> = {
      route: this.entry.route,
      site: this.entry.site,
    };

    this.loading = true;
    const request$ = this.isEdit
      ? this.evacuationRouteService.updateEvacuationRoute(this.currentBuildingId, String(this.itemToEdit!.id), payload)
      : this.evacuationRouteService.createEvacuationRoute(this.currentBuildingId, this.routeType, payload);

    request$.subscribe({
      next: (response) => {
        this.loading = false;
        if (!response.has_error) {
          this.onSave.emit({ type: 'success', message: this.isEdit ? 'This occurred after updating a route.' : 'This occurred after adding a route.' });
        } else {
          this.onSave.emit({ type: 'unsuccess', message: response.message });
        }
      },
      error: (err) => {
        this.loading = false;
        this.onSave.emit({ type: 'unsuccess', message: err.message });
      }
    });
  }
}
